const getLoaderState = (state) => state.zone.loading;

const getZones = (state) => state.zone.data;

const getFields = (state) => state.zone.fields;

const getZonesToSetup = (state) => {
  const zones = state.zone.data.filter(
    (item) => !item.vegetationType || !item.sprayHeadType || !item.soilType || !item.slopeType,
  );
  return zones;
};

const activeZones = (state) => {
  const zones = state.zone.data.filter((item) => item.enabled);
  return zones;
};

const selectors = {
  getLoaderState,
  getZones,
  getFields,
  getZonesToSetup,
  activeZones,
};

export default selectors;
